<template>
  <div class="goal-tile" @mouseover="hovered = true" @mouseleave="hovered = false">
    <div class="goal-tile__date">{{ $t('untilLabel') }} {{ formattedDateEnd }}</div>
    <div class="goal-tile__cover">
      <img :src="goalImage" alt="" @error="imageError = true">
    </div>
    <div class="goal-tile__title">{{ goal_title }}</div>
    <div class="flex items-end text-md text-text mb-5" v-show="status !== 2">
      <span><b>
        {{ displayCurrencyValue(summary.current_month_sum, currency, true, true) }}
      </b></span>
      <span class="mx-3">{{ $t('fromLabel') }}</span>
      <span><b>
        {{ displayCurrencyValue(summary.payment_plan, currency, true, true) }}
      </b></span>
      <span class="goal-tip text-xs text-text-ternary ml-4" v-if="goal_type === 1">{{ $t('accumulatedTip') }}</span>
      <span class="goal-tip text-xs text-text-ternary ml-4" v-else>{{ $t('redeemedTip') }}</span>
    </div>
    <ProgressWaves :width="summary.progress"
                   :text-display="progressText"
                   :color="summary.progress ? summary.color : 'default'"
                   size="small"/>
  </div>
</template>

<script>
import ProgressWaves from "@/components/common/ProgressWaves";
import {mapGetters} from "vuex";

export default {
  name: "GoalTile",
  components: {ProgressWaves},
  props: {
    goal_type: {
      type: Number,
    },
    goal_image_url: {
      type: String,
    },
    goal_title: {
      type: String
    },
    goal_date_end: {
      type: Number
    },
    goal_sum: {
      type: Number
    },
    currency: {
      type: Object
    },
    summary: {
      type: Object
    },
    status: {
      type: Number
    },

  },
  data() {
    return {
      hovered: false,
      imageError: false
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    goalImage() {
      return this.goal_image_url;
      // return this.imageError ? 'https://upload.wikimedia.org/wikipedia/commons/9/95/Vue.js_Logo_2.svg' : this.goal_image_url;
    },
    formattedDateEnd() {
      let monthRuLabels = ',января,февраля,марта,апреля,мая,июня,июля,августа,сентября,октября,ноября,декабря'.split(','),
          date = this.goal_date_end;
      if (this.$i18n.locale === 'ru') {
        let monthIndex = this.$moment.unix(date).format('M'),
            monthYear = this.$moment.unix(date).format('YYYY');
        date = `${monthRuLabels[monthIndex]} ${monthYear}`
      } else {
        date = this.$moment.unix(date).format('MMMM YYYY').toLowerCase()
      }
      return date
    },
    progressText() {
      if (!this.hovered) return `${Math.round(this.summary.progress)}%`
      return `${this.displayCurrencyValue(this.summary.payment_made, this.currency, true, true)} ${this.$t('fromLabel')} ${this.displayCurrencyValue(this.goal_sum, this.currency, true, true)}`
    }
  },
  i18n: {
    messages: {
      en: {
        fromLabel: 'in',
        untilLabel: 'Until',
        accumulatedTip: 'Accumulated this month',
        redeemedTip: 'Redeemed This Month'
      },
      ru: {
        fromLabel: 'из',
        untilLabel: 'До',
        accumulatedTip: 'Накоплено в этом месяце',
        redeemedTip: 'Погашено в этом месяце'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.goal-tile {
  @apply bg-block shadow-primaryBlock p-6 pb-5 rounded overflow-hidden relative cursor-pointer;

  &__date {
    @apply absolute top-6 left-6 rounded px-4 py-3
    text-white text-2sm font-bold
    bg-black-transparent80;
  }

  &__cover {
    @apply -mx-6 -mt-6 mb-8;
    height: 180px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__title {
    @apply text-xl font-bold text-text leading-tight mb-5 transition duration-200 truncate;
  }

  .goal-tip {
    @apply opacity-0 transition duration-200;
  }

  &:hover {
    .goal-tile__title {
      @apply text-red;
    }

    .goal-tip {
      @apply opacity-100;
    }
  }

}
</style>